import { render, staticRenderFns } from "./StepDataOra.vue?vue&type=template&id=48dcf07d"
import script from "./StepDataOra.vue?vue&type=script&lang=js"
export * from "./StepDataOra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports